import React from 'react';
import { Clock } from 'lucide-react';

export default function ActiviteEmptyState({ title, description, testId = 'activite-empty-state' }) {
  return (
    <div
      className="rounded-xl border p-8 text-center"
      style={{ background: 'var(--rm-bg-elevated)', borderColor: 'var(--rm-border-subtle)' }}
      data-testid={testId}
    >
      <Clock className="w-10 h-10 mx-auto mb-3 text-[var(--rm-gray-500)]" />
      <h3 className="text-lg font-semibold text-[var(--rm-white)] mb-2">{title}</h3>
      <p className="text-sm text-[var(--rm-gray-500)] max-w-md mx-auto">{description}</p>
    </div>
  );
}
